module.exports = __webpack_public_path__ + "static/media/less-equal.2fa4d2e9.svg";